import React, { useEffect, useState } from 'react';
import { getOrderItemsByOrderId, logError, updateSpecialProduct } from '../../api';
import SpecialProductStatus from './SpecialProductStatus';
import { isPropietarioOrAdminOrGestion } from '../../services/AuthService';
import useSpecialProductStatuses from '../../hooks/useSpecialProductStatuses';

const ItemsInfoRow = ({ order, refresh }) => {
  const { statuses: specialProductStatuses } = useSpecialProductStatuses();

  // Verifica si hay gastos de kilometraje
  const hasMileageCost = order.mileageCost > 0;

  // Verificar si hay productos (normales o especiales)
  const hasProducts = (order.items?.length > 0 || order.specialProducts?.length > 0);
  
  return (
    <div className="items-info" style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', margin: '10px' }}>
      {hasProducts ? (
        <>
          <h5 style={{ marginBottom: '15px', color: '#495057', borderBottom: '2px solid #dee2e6', paddingBottom: '8px' }}>
            <i className="bi bi-box-seam me-2"></i>Artículos del Pedido
          </h5>
          <div className="table-responsive">
            <table className="table table-hover table-sm">
              <thead className="table-light">
                <tr>
                  <th style={{ fontWeight: '600' }}>Producto</th>
                  <th style={{ fontWeight: '600' }}>Modelo</th>
                  <th style={{ fontWeight: '600' }}>Color</th>
                  <th style={{ fontWeight: '600' }}>Tamaño</th>
                  <th style={{ fontWeight: '600', textAlign: 'center' }}>Cant.</th>
                  <th style={{ fontWeight: '600', textAlign: 'right' }}>P. Unit.</th>
                  <th style={{ fontWeight: '600', textAlign: 'right' }}>Total</th>
                  {isPropietarioOrAdminOrGestion() && <th style={{ fontWeight: '600', textAlign: 'center' }}>Estado</th>}
                </tr>
              </thead>
              <tbody>
                {order.items?.map((item, index) => (
                  <React.Fragment key={`item-${index}`}>
                    <tr>
                      <td><strong>{item.productPrice.type?.typeName || '-'}</strong></td>
                      <td>{item.productPrice.model?.modelName || '-'}</td>
                      <td>{item.productPrice.color?.colorName || '-'}</td>
                      <td>{item.productPrice.size?.size || '-'}</td>
                      <td style={{ textAlign: 'center' }}><span className="badge bg-secondary">{item.quantity || 0}</span></td>
                      <td style={{ textAlign: 'right' }}>{item.unitPrice ? item.unitPrice.toFixed(2) : '0.00'}€</td>
                      <td style={{ textAlign: 'right' }}><strong>{(item.unitPrice * item.quantity).toFixed(2)}€</strong></td>
                      {isPropietarioOrAdminOrGestion() && <td></td>}
                    </tr>
                    {item.orderItemVariants && item.orderItemVariants.length > 0 && (
                      <tr>
                        <td colSpan={isPropietarioOrAdminOrGestion() ? "8" : "7"} style={{ paddingLeft: '25px', fontSize: '0.9em', color: '#6c757d', backgroundColor: '#f1f3f4' }}>
                          <i className="bi bi-arrow-return-right me-1"></i>
                          <strong>Variantes:</strong> {item.orderItemVariants.map(v => `${v.variant.name} (+${v.variant.priceDelta}€)`).join(', ')}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
                
                {order.specialProducts?.map((item, index) => (
                  <tr key={`special-${index}`} style={{ backgroundColor: '#e3f2fd', borderLeft: '4px solid #2196f3' }}>
                    <td>
                      <strong>{item.productType?.typeName || '-'}</strong>
                    </td>
                    <td colSpan="3" style={{ color: '#555' }}>
                      <span className="badge bg-info me-2">Especial</span>
                      {item.description}
                    </td>
                    <td style={{ textAlign: 'center' }}><span className="badge bg-secondary">{item.quantity || 1}</span></td>
                    <td style={{ textAlign: 'right' }}>{item.price ? item.price.toFixed(2) : '0.00'}€</td>
                    <td style={{ textAlign: 'right' }}><strong>{(item.price * (item.quantity || 1)).toFixed(2)}€</strong></td>
                    {isPropietarioOrAdminOrGestion() && (
                      <td style={{ textAlign: 'center' }}>
                        <SpecialProductStatus 
                          specialProductId={item.id} 
                          currentStateId={item.stateValueId} 
                          statusOptions={specialProductStatuses}
                          onStateChange={(newStateId) => {
                            updateSpecialProduct(item.id, { stateValueId: Number(newStateId) });
                          }}
                        />
                      </td>
                    )}
                  </tr>
                ))}
                
                {hasMileageCost && (
                  <tr style={{ backgroundColor: '#fff3cd', borderLeft: '4px solid #ffc107' }}>
                    <td colSpan="5">
                      <i className="bi bi-speedometer2 me-2"></i>
                      <strong>Kilometraje:</strong> {order.mileage || 0} km
                    </td>
                    <td style={{ textAlign: 'right' }}><strong>Gastos:</strong></td>
                    <td style={{ textAlign: 'right' }}><strong>{order.mileageCost.toFixed(2)}€</strong></td>
                    {isPropietarioOrAdminOrGestion() && <td></td>}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="text-center text-muted py-4">
          <i className="bi bi-inbox display-4 d-block mb-2"></i>
          <p>No hay productos en este pedido</p>
        </div>
      )}
    </div>
  );
};

export default ItemsInfoRow;
